import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import getVideoByIdQuery from 'modules/media/graphql/queries/getVideoByIdQuery';

export default function useVideo({ courseId, subjectId, videoId }) {
  /**
   * Get Video
   */
  const { data, loading, error, refetch } = useQuery(getVideoByIdQuery, {
    variables: {
      courseId,
      subjectId,
      videoId,
    },
    skip: !courseId || !subjectId || !videoId,
    fetchPolicy: 'network-only',
  });

  const video = useMemo(() => data?.video || {}, [data]);

  return {
    video,
    loading,
    error: getErrorMessage({ error }),
    refetchVideo: refetch,
  };
}
